export const getBidReviewerPayButtonStyle = (theme) => ({
    position: 'relative',
    left: '10px',
    textAlign: 'left',
    float: 'left',
    marginLeft: '10px',
});
